export default __webpack_public_path__ + "static/media/8e8add7f4e9817edab5b9413107c0f2a1602889253792.1fbefda2.webp";